import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityFilters } from '@/shared/types/entity';
import { replacementBatchesApi } from '../api';
import type { ReplacementBatch, ReplacementBatchFormData } from '../types';

const initialState = {
  items: [] as ReplacementBatch[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 20,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
  } as EntityFilters,
};

const { actions, reducer } = createEntitySlice<
  ReplacementBatch,
  EntityFilters,
  ReplacementBatchFormData
>({
  name: 'replacementBatches',
  api: replacementBatchesApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage } = state.replacementBatches;
    return { page: currentPage, perPage };
  },
});

export const {
  fetchItems: fetchReplacementBatches,
  createItem: createReplacementBatch,
  updateItem: updateReplacementBatch,
  deleteItem: deleteReplacementBatch,
  setPage,
  setPerPage,
  setFilters,
} = actions;

export { reducer };
